import { render, staticRenderFns } from "./pages14.vue?vue&type=template&id=ffb57902&scoped=true&"
import script from "./pages14.vue?vue&type=script&lang=js&"
export * from "./pages14.vue?vue&type=script&lang=js&"
import style0 from "./pages14.vue?vue&type=style&index=0&id=ffb57902&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffb57902",
  null
  
)

export default component.exports